module.exports = __webpack_public_path__ + "static/media/Pukeberries.1d7d5a1a.png";